import { Drawer } from '@/new/components/drawers/drawer';
import { ChunkDocumentDrawerContent } from '@/new/components/reference-content/chunk-document-drawer-content';

interface ChunkDrawerProps {
  chunkId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function ChunkDrawer({ chunkId, isOpen, onClose }: ChunkDrawerProps) {
  return (
    <Drawer isOpen={isOpen} onClose={onClose} hideCloseButton={true}>
      {chunkId && <ChunkDocumentDrawerContent chunkId={chunkId} />}
    </Drawer>
  );
}
